import { useTheme } from "@mui/material/styles";

export default function Template3Top({ height = 80, width = "100%" }) {
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 761 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        "--accent": primary,
        "--accent-dark": primary,
        "--light": "#ffffff",
        "--dark": "#000000"
      }}
      role="img"
      aria-label="Decorative ribbon"
    >
      <g clipPath="url(#clip0_18456_304010)">
        <path
          d="M716.527 -16.9688L761.263 -52.2463L763.657 -50.3583C787.025 -31.9311 787.025 -2.00636 763.657 16.4208L761.263 18.3088L716.527 -16.9688Z"
          fill="var(--accent)"
        />
        <path
          d="M38.5137 -16.8125L1.75645 18.4651L-0.210712 16.5771C-19.4108 -1.85012 -19.4108 -31.7749 -0.21071 -50.2021L1.75645 -52.0901L38.5137 -16.8125Z"
          fill="var(--accent)"
        />
        <path
          d="M755 18.9141H737.49L7.88335 18.9141L25.3934 0.914062H737.49L755 18.9141Z"
          fill="var(--accent)"
        />
      </g>
      <defs>
        <clipPath id="clip0_18456_304010">
          <rect width="761" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
